import React from 'react'
import { Routes, Route, Link } from "react-router-dom";
import { Badge } from 'react-bootstrap'
import Cart from './Cart';
import { useSelector } from 'react-redux'
import Category from './Category';
import Details from './Details';
import Home from './Home';;

function Navbar() {
  const {quantity}=useSelector((state)=>state.cart);
  return (
    <>
      <nav className="navbar navbar-expand-lg bg-body-tertiary sticky-top">
  <div className="container">
    <Link className="navbar-brand" to="/"><img src={require('../images/logo_dark.png')}/></Link>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon" />
    </button>
    <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
      <ul className="navbar-nav mb-2 mb-lg-0 align-items-center">
      <li className="nav-item dropdown home me-2">
          <Link className="nav-link dropdown-toggle active text-danger fonts fw-semibold" to='/' role="button" data-bs-toggle="dropdown" aria-expanded="false">
            HOME
          </Link>
          <ul className="dropdown-menu">
            <li><a className="dropdown-item py-2 px-4" href="#">Fashion 1</a></li>
            <li><a className="dropdown-item py-2 px-4" href="#">Fashion 2</a></li>
            <li><a className="dropdown-item py-2 px-4" href="#">Furniture 1</a></li>
            <li><a className="dropdown-item py-2 px-4" href="#">Furniture 2</a></li>
            <li><a className="dropdown-item py-2 px-4" href="#">Electronics 1</a></li>
            <li><a className="dropdown-item py-2 px-4" href="#">Electronics 2</a></li>
          </ul>
        </li>
        <li className="nav-item dropdown home me-2">
          <Link className="nav-link dropdown-toggle right fonts fw-semibold" to="/" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          PAGES
          </Link>
          <ul className="dropdown-menu">
            <li><a className="dropdown-item py-2 px-4" href="#">About Us</a></li>
            <li><a className="dropdown-item py-2 px-4" href="#">Contact Us</a></li>
            <li><a className="dropdown-item py-2 px-4" href="#">Faq</a></li>
            <li><a className="dropdown-item py-2 px-4" href="#">404 Error Page</a></li>
            <li><a className="dropdown-item py-2 px-4" href="#">Login</a></li>
            <li><a className="dropdown-item py-2 px-4" href="#">Register</a></li>
            <li><a className="dropdown-item py-2 px-4" href="#">Terms and Conditions</a></li>
          </ul>
        </li>
        <li className="nav-item dropdown position-static home me-2">
  <a className="nav-link dropdown-toggle right fonts fw-semibold" href="#" id="navbarDropdown" role="button" data-mdb-toggle="dropdown" aria-expanded="false">
    PRODUCTS
  </a>
  <div className="dropdown-menu mega" aria-labelledby="navbarDropdown" >
    <div className="container py-4">
      <div className="row my-4">
        <div className="col-md-6 col-lg-3 mb-3 mb-lg-0 border-end">
          <div className="list-group list-group-flush">
            <li><h5 className='text-start px-2 pb-2'>Woman's</h5></li>
            <a href className="list-group-item list-group-item-action">Vestibulum sed</a>
            <a href className="list-group-item list-group-item-action">Donec porttitor</a>
            <a href className="list-group-item list-group-item-action">Donec vitae facilisis</a>
            <a href className="list-group-item list-group-item-action">Curabitur tempus</a>
            <a href className="list-group-item list-group-item-action">Vivamus in tortor</a>
          </div>
        </div>
        <div className="col-md-6 col-lg-3 mb-3 mb-lg-0 border-end">
          <div className="list-group list-group-flush ms-3">
          <li><h5 className='text-start ps-2 pb-2'>Men's</h5></li>
            <a href className="list-group-item list-group-item-action">Donec vitae ante ante</a>
            <a href className="list-group-item list-group-item-action">Etiam ac rutrum</a>
            <a href className="list-group-item list-group-item-action">Quisque condimentum</a>
            <a href className="list-group-item list-group-item-action">Curabitur laoreet</a>
            <a href className="list-group-item list-group-item-action">Vivamus in tortor</a>
          </div>
        </div>
        <div className="col-md-6 col-lg-3 mb-3 mb-md-0 border-end">
          <div className="list-group list-group-flush ms-3">
          <li><h5 className='ps-2 pb-2'>Kid's</h5></li>
            <a href className="list-group-item list-group-item-action">Donec vitae facilisis</a>
            <a href className="list-group-item list-group-item-action">Quisque condimentum</a>
            <a href className="list-group-item list-group-item-action">Est iure</a>
            <a href className="list-group-item list-group-item-action">Praesentium</a>
            <a href className="list-group-item list-group-item-action">Laboriosam</a>
          </div>
        </div>
        <div className="col-md-6 col-lg-3">
          <div className="list-group list-group-flush ms-3">
          <li><h5>Accessories</h5></li>
            <a href className="list-group-item list-group-item-action">Cras justo odio</a>
            <a href className="list-group-item list-group-item-action">Saepe</a>
            <a href className="list-group-item list-group-item-action">Vel alias</a>
            <a href className="list-group-item list-group-item-action">Sunt doloribus</a>
            <a href className="list-group-item list-group-item-action">Cum dolores</a>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-lg-4 px-2'>
          <img className='w-100 ' src={require('../images/menu1.jpg')}/>
        </div>
        <div className='col-lg-4 px-2'>
        <img className='w-100 ' src={require('../images/menu2.jpg')}/>
        </div>
        <div className='col-lg-4 px-2'>
        <img className='w-100 ' src={require('../images/menu3.jpg')}/>
        </div>
      </div>
    </div>
  </div>
         </li>      
            <li className="nav-item dropdown home me-2">
          <Link className="nav-link dropdown-toggle right fonts fw-semibold" to="/" role="button" data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="false">
          BLOG
          </Link>
          <ul className="dropdown-menu dropdown-menu-end dropdown-menu-lg-start page">
            <li>
              <div className='d-flex align-items-center me-2 '>
                 <a className="dropdown-item py-2 pe-5 me-5 rig" href="#">Grids</a>
                 <Link to='/'><i class="bi bi-chevron-right right"></i></Link>
              </div>
            </li>
            <li>
              <div className='d-flex align-items-center me-2 '>
                 <a className="dropdown-item py-2 pe-5 me-5" href="#">Masonry</a>
                 <Link to='/'><i class="bi bi-chevron-right right"></i></Link>
              </div>
            </li>
            <li>
              <div className='d-flex align-items-center me-2 '>
                 <a className="dropdown-item py-2 pe-5 me-5" href="#">Single Post</a>
                 <Link to='/'><i class="bi bi-chevron-right right"></i></Link>
              </div>
            </li>
            <li>
              <div className='d-flex align-items-center me-2 '>
                 <a className="dropdown-item py-2 pe-5 me-5" href="#">List</a>
                 <Link to='/'><i class="bi bi-chevron-right right"></i></Link>
              </div>
            </li>
          </ul>
        </li>
        <li className="nav-item dropdown position-static home me-2">
  <a className="nav-link dropdown-toggle right fonts fw-semibold" href="#" id="navbarDropdown" role="button" data-mdb-toggle="dropdown" aria-expanded="false">
    SHOP
  </a>
  <div className="dropdown-menu mega" aria-labelledby="navbarDropdown" >
    <div className="container py-4">
      <div className="row my-4">
        <div className="col-md-6 col-lg-3 mb-3 mb-lg-0 border-end">
          <div className="list-group list-group-flush">
            <li><h5 className='text-start px-2'>Woman's</h5></li>
            <a href className="list-group-item list-group-item-action">Vestibulum sed</a>
            <a href className="list-group-item list-group-item-action">Donec porttitor</a>
            <a href className="list-group-item list-group-item-action">Donec vitae facilisis</a>
            <a href className="list-group-item list-group-item-action">Curabitur tempus</a>
          </div>
        </div>
        <div className="col-md-6 col-lg-3 mb-3 mb-lg-0 border-end">
          <div className="list-group list-group-flush ms-3">
          <li><h5 className='text-start ps-2'>Men's</h5></li>
            <a href className="list-group-item list-group-item-action">Donec vitae ante ante</a>
            <a href className="list-group-item list-group-item-action">Etiam ac rutrum</a>
            <a href className="list-group-item list-group-item-action">Quisque condimentum</a>
            <a href className="list-group-item list-group-item-action">Curabitur laoreet</a>
          </div>
        </div>
        <div className="col-md-6 col-lg-3 mb-3 mb-md-0 border-end">
          <div className="list-group list-group-flush ms-3">
          <li><h5 className='ps-2'>Kid's</h5></li>
            <a href className="list-group-item list-group-item-action">Donec vitae facilisis</a>
            <a href className="list-group-item list-group-item-action">Quisque condimentum</a>
            <a href className="list-group-item list-group-item-action">Est iure</a>
            <a href className="list-group-item list-group-item-action">Praesentium</a>
          </div>
        </div>
        <div className="col-md-6 col-lg-3">
          <div className="list-group list-group-flush ms-3">
          <img className='w-100 ' src={require('../images/shopbanner.jpg')}/>
          </div>
        </div>
      </div>
    </div>
  </div>
         </li>  
        <li className="nav-item dropdown position-static home me-2">
        <Link className="nav-link dropdown-toggle right fonts fw-semibold" to='/' role="button" data-bs-toggle="dropdown" aria-expanded="false">
            CONTACT US
          </Link>
        </li> 
        <form className="d-flex position-relative" role="search">
  <input className="form-control me-2 py-2" type="search" placeholder="Search" aria-label="Search" />
  <Link className="nav-link fs-5 right me-2 search" to='/' role="button" data-bs-toggle="dropdown" aria-expanded="false">
          <i class="bi bi-search"></i>
          </Link>
</form>

      </ul>
    </div>
    
    <div className='right'>
    <Link className='btn position-relative' to="/cart">
    <i class="bi bi-cart3 fs-3 text-secondary "></i><Badge className='bg-danger badge rounded-circle'>{quantity}</Badge>
    </Link>
      </div>
  </div>
</nav>

<Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/cat/:aid" element={<Category />} />
        <Route path="/details/:did" element={<Details />} />
      </Routes>
    </>
  )
}

export default Navbar
